import React, { useState } from 'react';

import AppleSubscriptionPopup from './AppleSubscriptionPopup';

const useAppleSubscriptionPopup = () => {
    const [isOpen, setIsOpen] = useState(false);
    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);
    const popup = <AppleSubscriptionPopup isOpen={isOpen} onClose={close} />;
    return { open, popup };
};

export default useAppleSubscriptionPopup;
